import { createTransform } from 'redux-persist'
import { TemplateState, initialState } from './templateSlice'
import { RootState } from '../../types/RootState'

export const transformer = createTransform<
  TemplateState,
  Omit<TemplateState, 'currentRequest' | 'error'>,
  RootState
>(
  inboundState => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { error, currentRequest, ...persistedState } = inboundState
    return persistedState
  },
  outboundState => {
    const status: TemplateState['status'] =
      outboundState.status === 'initial' ? outboundState.status : 'idle'
    return {
      ...outboundState,
      error: initialState.error,
      currentRequest: initialState.currentRequest,
      status,
    }
  },
  {
    whitelist: ['template'],
  },
)
